import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import smoothscroll from 'smoothscroll-polyfill';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import FeedbackWidget from './feedback/feedbackWidget';
import Footer from './layout/footer';
import Header from './layout/header';
import LogoutCounter from './layout/logoutCounter';
import SidebarLayout from './layout/SidebarLayout';
import LoginFormContainer from './login/loginFormContainer';
import routes from '../routes';
import { ThemeProvider, useTheme } from './theme/ThemeProvider';
import entityComposition from './common/classes/entityComposition';
import { removeItem } from '../utils/localStorage';

/**
 * Needed to support scrollTo on Edge
 */
smoothscroll.polyfill();

/**
 * Inner component that reads the theme context and renders the correct layout shell.
 * Must be a function component so it can use the useTheme hook (class components
 * cannot use hooks directly).
 */
const AppShell = ({
  isEntraCallbackRoute
}) => {
  const {
    layout
  } = useTheme();
  const mainContent = /*#__PURE__*/React.createElement(DndProvider, {
    backend: HTML5Backend
  }, routes);
  if (layout === 'sidebar' && !isEntraCallbackRoute) {
    return /*#__PURE__*/React.createElement(SidebarLayout, null, mainContent, /*#__PURE__*/React.createElement(LogoutCounter, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isEntraCallbackRoute && /*#__PURE__*/React.createElement(Header, null), mainContent, !isEntraCallbackRoute && /*#__PURE__*/React.createElement(Footer, null), !isEntraCallbackRoute && /*#__PURE__*/React.createElement(LogoutCounter, null));
};
AppShell.propTypes = {
  isEntraCallbackRoute: PropTypes.bool.isRequired
};

// define main App component including redux wrapper.
class App extends Component {
  componentDidMount() {
    const {
      loginActions
    } = this.props;
    // App mounted successfully, so reset the ErrorBoundary refresh guard.
    removeItem('errorBoundaryRefreshCount');
    loginActions.getUserFromSession();
  }
  render() {
    const {
      location
    } = this.props;
    // Check if we're on the Entra callback route
    // Don't render Header/Footer during Entra callback to prevent premature API calls
    // (ConfigBehavior and CustomerSettings API calls can interfere with authentication flow)
    const isEntraCallbackRoute = (location === null || location === void 0 ? void 0 : location.pathname) === '/auth/callback' || typeof window !== 'undefined' && (window.location.pathname === '/auth/callback' || window.location.hash.includes('/auth/callback') || window.location.hash.includes('code='));
    return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoginFormContainer, null, /*#__PURE__*/React.createElement(AppShell, {
      isEntraCallbackRoute: isEntraCallbackRoute
    }), !isEntraCallbackRoute && /*#__PURE__*/React.createElement(FeedbackWidget, null))));
  }
}
App.propTypes = {
  loginActions: PropTypes.shape({
    getUserFromSession: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};
App.defaultProps = {
  location: undefined
};

// Connect the App.
// Wrap the ConnectedClass `withRouter` to ensure route location updates are handled.
// more details: https://tinyurl.com/y9oq9aub
const ConnectedApp = withRouter(entityComposition(App, [], {
  customer: state => state.login.customer
}, ['login']));
export { App as TestApp };
export default ConnectedApp;